import { gsap } from 'gsap'
//
document.addEventListener('DOMContentLoaded', () => {

  const $articles = $(".articles");
  const $practices_nav = $(".practices .nav li");
  const $header = $('.globalHeader');
  const $header_logo = $(".globalHeader .logo");
  const $section = $("section");
  const $mv = $(".mv");
  const $mv_img = $(".mv_img");
  const $page_info = $('.page_info');
  const $bg_w = $(".bg_w");

  var ww = window.innerWidth;
  // var hh = window.innerHeight;
  var mv_img_h = $mv_img.height();

  $(window).on('load', function() {

    $('body').addClass('load');
    // $header.height(hh);

    if (Useragnt.ios){
      $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    //　top以外はグレー背景
    if($mv.length < 1){
      $header.addClass("gray");
    }

    // 白背景の高さ
    if(ww < 751){
      if($("main").hasClass("PracticesArticle")){
        var top_h = $(".top_img").offset().top;
        $bg_w.css("height", top_h);
      }
    }else{
      if($("main").hasClass("PracticesArticle")){
        var top_h = $(".top_img").offset().top;
        var bg_w_h = top_h + 160;
        $bg_w.css("height", bg_w_h);
      }
    }

    if(ww < 751){
      new ScrollHint('.js-scrollable');
    }
    

    if($(".practices").length) {
      $.getJSON("../assets/json/practices.json")
      .done(function (json) {
        practices(json);
      });
      $.getJSON("../assets/json/other.json")
      .done(function (other_json) {
        other(other_json);
      });
    }

  });

  $(document).on("click", ".practices .nav li", function(){
    $practices_nav.removeClass("active");
    var nav_class = $(this).attr("class");
    $(this).addClass("active");
    TweenMax.to(".article_set", 0,{
      opacity: 0,
      onComplete : function(){
        $(".article_set").removeClass("active");
        if(nav_class == "all"){
          $(".other").addClass("active");
          $("."+nav_class).addClass("active");
        }else{
          $("."+nav_class).addClass("active");
        }
        TweenMax.to(".article_set", 0.5,{
          opacity: 1
        });
      }
    });
  });
  $(document).on("click", ".menu_btn", function(){
    $(this).toggleClass("active");
    $(".menu_nav").toggleClass("active");
    $("body").toggleClass("noScroll");
  });
  $(document).on("click", ".copy_btn", function(){
    var copy_text = $(this).data("share");
    var clipboard = $("<textarea></textarea>");
    clipboard.text(copy_text);
    $('body').append(clipboard);

    clipboard.select();
    document.execCommand("copy");
    clipboard.remove();

    alert("リンクをコピーしました");
  });

  if($('.scroll-x').scrollLeft()){
    $('.suggest').fadeOut;
    console.log('scroll!')
  }

  $(window).scroll(function() {

    var scr = $(window).scrollTop();
    // var scr_hh = scr + hh;

    if ($('body').hasClass('load')) {
      scrollShow();
    }

    // ヘッダー背景の色
    if($(".page_info") && !$(".practices")){
      if(scr > $(".page_info").outerHeight()){
        $header.addClass("white");
        $header.removeClass("gray");
      }else{
        $header.removeClass("white");
        $header.addClass("gray");
      }
    }
    if($(".top_img")){
      if(scr > 1 && scr < $bg_w.height()){
        $header.addClass("white");
        $header.removeClass("gray");
      }else{
        $header.removeClass("white");
        $header.addClass("gray");
      }
    }
    if($mv.length){
      if(scr > mv_img_h){
        $header.addClass("gray");
      }else{
        $header.removeClass("gray");
      }
    }
  });


    $(window).resize(function() {
    });


  function scrollShow() {
    $('.scroll-show').each(function(i, elm) {

      const $wh = $(window).height();
      const $st = $(window).scrollTop();
      const $sb = $st + $wh * .75;

      if ($(elm).is('.is-show')) {
        return true;
      }

      const $pos = $(elm).offset().top;
      if ($pos < $sb) {
        $(elm).addClass('is-show');
      }
      return;
    });
  }

  function practices(json){

    var url_pas = location.href;
    var practices_html = "";
    var nav_ary = ["all", "drr", "tra", "liv", "dev"];
    var set_pas = "./";
    if (url_pas.indexOf('goodpractices') !== -1) {
      set_pas = "../";
    }

    for (var n = 0; n < nav_ary.length; n++) {

      var large_html = "";
      var small_html = "";
      var practices_num = 0;
      var size_check = false;
      var type = nav_ary[n];

      if(type == "all"){
        practices_html += '<div class="article_set ' + type + ' active">';
      } else {
        practices_html += '<div class="article_set ' + type + '">';
        // All以外はjsonをid昇順に並べ替え　≒　L記事を一番目
        json.sort(function(val1, val2) {
          return ( val2.id < val1.id ? 1 : -1);
        });
      }

      practices_html += '<ul class="article">';

      for (var i = 0; i < json.length; i++) {
        var link = json[i].link;
        var text = json[i].text;
        var icon_1 = json[i].icon_1;
        var icon_2 = json[i].icon_2;
        var size = json[i].size;
        var icon_html = "";

        if(icon_1 == type || icon_2 == type || type == "all"){
          // そのカテゴリの時だけL記事表示
          if(size == "large" && type != "all" && icon_1 == type){

            if(icon_1){
              icon_html += '<img src="' + set_pas + 'assets/img/icon/icon_' + icon_1  + '_w.svg" alt="">';
            }
            if(icon_2){
              icon_html += '<img src="' + set_pas + 'assets/img/icon/icon_' + icon_2  + '_w.svg" alt="">';
            }
            large_html =
              '<li class="large">' +
                '<a href="' + set_pas + 'goodpractices/' + link +'.html">' +
                  '<img src="' + set_pas + 'assets/img/practices/' + link + '/thumb_l.jpg" alt="">' +
                  '<div class="text">' +
                    '<p>' + text + '</p>' +
                    '<div class="icon">' + icon_html + '</div>' +
                  '</div>' +
                '</a>' +
              '</li>';

            practices_num += 1;
            size_check = true;
          } else {

            if(icon_1){
              icon_html += '<img src="' + set_pas + 'assets/img/icon/icon_' + icon_1  + '_g.svg" alt="">';
            }
            if(icon_2){
              icon_html += '<img src="' + set_pas + 'assets/img/icon/icon_' + icon_2  + '_g.svg" alt="">';
            }

            small_html +=
              '<li class="small">' +
                '<a href="' + set_pas + 'goodpractices/' + link +'.html">' +
                  '<img src="' + set_pas + 'assets/img/practices/' + link + '/thumb.jpg" alt="">' +
                  '<div class="text">' +
                    '<p>' + text + '</p>' +
                    '<div class="icon visible-pc">' + icon_html + '</div>' +
                  '</div>' +
                  '<div class="icon visible-sp">' + icon_html + '</div>' +
                '</a>' +
              '</li>';

            practices_num += 1;
          }
        }

        if(ww < 751){
          if(practices_num == 5 || i+1 == json.length){
            if(size_check && type != "all"){
              practices_html += large_html + small_html;
              size_check = false;
            } else {
              practices_html += small_html;
            }
            practices_num = 0;
            large_html = "";
            small_html = "";
          }
        } else {
          if(practices_num == 4 || i+1 == json.length){
            if(size_check && type != "all"){
              practices_html +=
                '<li>' +
                  '<ul class="large_column">' +
                    large_html +
                    '<li class="small_set">' +
                      '<ul>' +
                        small_html +
                      '</ul>' +
                    '</li>' +
                  '</ul>' +
                '</li>';

              size_check = false;
            } else {
              practices_html += small_html;
            }
            practices_num = 0;
            small_html = "";
            large_html = "";
          }
        }
      }

      practices_html += '</ul></div>';
    }
    $articles.html(practices_html);
  }

    function other(other_json){
      var other_html = '<div class="article_set other active"><h2 class="other_ttl">Tool & Research</h2><ul class="article">';
      var o_small_html = "";
      var o_practices_num = 0;
      var o_set_pas = "./";
      var o_url_pas = location.href;
      if (o_url_pas.indexOf('goodpractices') !== -1) {
        o_set_pas = "../";
      }

        for (var j = 0; j < other_json.length; j++) {
          var o_link = other_json[j].link;
          var o_text = other_json[j].text;
          var o_icon_1 = other_json[j].icon_1;
          var o_icon_2 = other_json[j].icon_2;
          var o_icon_html = "";

          if(o_icon_1){
            o_icon_html += '<img src="' + o_set_pas + 'assets/img/icon/icon_' + o_icon_1  + '_g.svg" alt="">';
          }
          if(o_icon_2){
            o_icon_html += '<img src="' + o_set_pas + 'assets/img/icon/icon_' + o_icon_2  + '_g.svg" alt="">';
          }

          o_small_html +=
            '<li class="small">' +
              '<a href="' + o_set_pas + 'goodpractices/' + o_link +'.html">' +
                '<img src="' + o_set_pas + 'assets/img/practices/' + o_link + '/thumb.jpg" alt="">' +
                '<div class="text">' +
                  '<p>' + o_text + '</p>' +
                  '<div class="icon visible-pc">' + o_icon_html + '</div>' +
                '</div>' +
                '<div class="icon visible-sp">' + o_icon_html + '</div>' +
              '</a>' +
            '</li>';

          o_practices_num += 1;

          if(ww < 751){
            if(o_practices_num == 5 || j+1 == other_json.length){
              other_html += o_small_html;
              o_practices_num = 0;
              o_small_html = "";
            }
          } else {
            if(o_practices_num == 4 || j+1 == other_json.length){
              other_html += o_small_html;
              o_practices_num = 0;
              o_small_html = "";
            }
          }

        }

      other_html += '</ul></div>';
      $("div.articles").append(other_html);

    }
});
